import React from "react";

/*eslint-disable */

declare const window: any;

interface OtrosVehiculosDinamicoComponentProps {
  opportunities: any;
}

const OtrosVehiculosDinamicoComponent: React.FC<
  OtrosVehiculosDinamicoComponentProps
> = ({ opportunities }) => {
  return (
    <div className="otros-vehiculos-detail-component">
      <div className="title-otros-vehiculos-detail-component">
        Más oportunidades{/* Oportunidades para este vehículo */}
      </div>
      <div className="opciones-otros-vehiculos-detail-component">
        {opportunities?.map((item: any) => (
          <div
            className={`item-opciones-otros-vehiculos-detail-component`}
            style={{
              backgroundImage:
                `URL(https://manager.hyundaicolombia.co/${item?.image?.url || item?.media[0]?.url})`,
            }}
          >
            <div
              className={`mascara-item-opciones-otros-vehiculos-detail-component`}
            >
              <div className="title-mascara-item-opciones-otros-vehiculos-detail-component">
                {item?.title}
              </div>
              <a
                href={item?.url}
                className="btn-page-other-page-home-component"
              >
                {item?.button_text || item?.title}
              </a>
            </div>
          </div>
        ))}
        
      </div>
    </div>
  );
};

export default OtrosVehiculosDinamicoComponent;
